import { COPYRIGHT_ENGLISH } from "../constants.js";
export const en = {
    "application_title": "Appoint Me",
    "these_zesty_duck_nudge": "Basic Information",
    "north_least_gopher_burn": "What is the purpose of this appointment type?",
    "lazy_just_duck_spin": "Event title",
    "Confirm meeting": "Confirm meeting",
    "Meeting with {{name}}": "Meeting with {{name}}",
    "Daily availability": "Daily availability",
    "tiny_factual_platypus_pave": "Where does the meeting take place?",
    "less_equal_octopus_dine": "Customizable part of the URL",
    "quiet_male_yak_slurp": "Event Slug",
    "honest_weak_iguana_rest": "Location",
    "dizzy_quiet_walrus_hush": "awesome-meeting",
    "tired_whole_bumblebee_type": "Zoom Meeting",
    "these_moving_fox_create": "Description",
    "quaint_known_wasp_view": "Minimum days in advance",
    "pretty_grand_cuckoo_arrive": "Events cannot be scheduled less than this time in advance",
    "slow_maroon_spider_praise": "Maximum number of events of this type per day",
    "grand_wacky_ox_flow": "Maximum per day",
    "left_aloof_stork_leap": "buffer-before",
    "elegant_early_boar_accept": "How long is this event?",
    "ideal_this_coyote_inspire": "Duration",
    "jumpy_tasty_rook_trust": "Duration",
    "real_big_crow_push": "Buffer before this event",
    "mealy_happy_ray_flop": "Buffer before",
    "close_actual_deer_boil": "Buffer after",
    "keen_zippy_bulldog_gaze": "Buffer after this event",
    "seemly_fine_octopus_slurp": "Availability",
    "each_awake_tadpole_jest": "Edit Event Type",
    "extra_patient_warbler_praise": "No events to book",
    "petty_swift_piranha_rise": "Schedule event",
    "broad_close_butterfly_drop": "Schedule an appointment with {{name}}",
    "weary_known_gazelle_file": "Please select the type of appointment you need and click on the schedule\n      button to book it. You will get a list of available slots in my schedule.",
    "low_clean_haddock_bubble": "My Event Types",
    "My Event Types": "My Event Types",
    "pink_trite_ocelot_enrich": "You need to connect your Calendar first, before you can add Events!",
    "early_sweet_mantis_peek": "Add event type",
    "deft_suave_bear_pause": "Loading",
    "equal_jolly_thrush_empower": " minutes",
    "Schedule an appointment": "Schedule an appointment",
    "heroic_kind_llama_zip": "Back",
    "awake_jolly_gazelle_lock": "Skip",
    "whole_acidic_parrot_promise": "Book appointment",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "Step {{val}}",
    "extra_misty_panda_grip": "Users can use this link to book appointments.",
    "sunny_great_halibut_empower": "Create the first",
    "create_first_event_type_button": "Event Type",
    "orange_grand_racoon_fall": "How {{app_title}} works",
    "male_patient_hedgehog_ask": "{{app_title}} is a simple, easy to use, appointment booking system. It            allows you to create events, share your link and let users book            appointments with you.",
    "factual_moving_hawk_belong": "Specify where {{app_title}} adds your appointments and where it checks whether you are busy.",
    "step_1_configure_calendars": "Step 1: Configure calendars",
    "pink_polite_racoon_earn": "Step 2: Create events",
    "happy_wise_mantis_laugh": "\"Add your available times and you're\n                good to go!\"",
    "careful_misty_bullock_splash": "Step 3: Share your link",
    "game_frail_vole_treasure": "Done! Congrats!",
    "still_helpful_koala_trust": "Once a user books an appointment, the event is added to your calendar.",
    "steep_fine_lobster_inspire": "Failed to save event type",
    "best_due_parakeet_zip": "Event type created!",
    "happy_caring_fox_spur": "Event saved",
    "tasty_witty_stingray_hope": "Error saving event",
    "trite_warm_gorilla_pet": "Add appointments to calendar",
    "aware_alert_mare_glow": "Check free time in calendars",
    "factual_nimble_snail_clap": "Save Changes",
    "tiny_teary_clownfish_vent": "Cancel",
    "lower_born_finch_dash": "Disconnect from Google",
    "whole_formal_liger_rise": "Connect Google Calendar",
    "pink_loose_cougar_grin": "My Calendar",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "Configuration",
    "big_known_loris_revive": "Choose calendars to check for busy times.",
    "large_suave_gull_hush": "copy link",
    "misty_proud_mallard_assure": "Copy link",
    "teal_lofty_hawk_peek": "Cancel",
    "mild_raw_elk_delight": "Save Changes",
    "Choose date": "Choose date",
    "Please select a date": "Please select a date",
    "Choose time": "Choose time",
    "Provide details": "Provide details",
    "Confirmation": "Confirmation",
    "Please share anything that will help me to prepare for our meeting": "Please share anything that will help me to prepare for our meeting",
    "Name": "Name",
    "Please provide your name": "Please provide your name",
    "Email": "Email",
    "Information": "Information",
    "You will receive a confirmation email": "You will receive a confirmation email",
    "Meeting with": "Meeting with",
    "Change": "Change",
    "Back": "Back",
    "Add Event Type": "Add Event Type",
    "Confirm & Book": "Confirm & Book",
    "availableSlots": "The following slots are available on {{date}}. Reserve one or choose another day.",
    "minutes": "minutes",
    "Days": "Days",
    "Maximum days in advance": "Maximum days in advance",
    "event_advance_availability_description": "How many days in advance is this event type available?",
    "none": "None",
    "edit": "Edit",
    "Select buffer": "Select buffer",
    "Save": "Save",
    "Select duration": "Select duration",
    "Starttime": "Start time",
    "Endtime": "End time",
    "Add Account": "Add Account",
    "Add CalDav Account": "Add CalDav Account",
    "CalDav Accounts": "CalDav Accounts",
    "Server URL": "Server URL",
    "Username": "Username",
    "label_password": "Password",
    "Notice": "Notice",
    "No slots available for the selected period.": "No slots available for the selected period.",
    "send_invitation_email": "Send invitation email",
    "send_invitation_email_notice": "Only needed if your CalDAV server does not send invitations automatically.",
    "invitationSubject": "Invitation: {{summary}}",
    "invitationBody": "<p>Hi {{attendeeName}},</p><p>You have been invited to the following event:</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>Time:</strong> {{time}}</p><p>Please find the event details attached.</p>",
    "icsDescription": "Event Description:\n{{description}}",
    "dateFormat": "en-US",
    "user_menu_log_out": "Log out",
    "user_menu_log_in": "Log in",
    "user_menu_profile": "Profile",
    "user_menu_my_account": "My account",
    "user_menu_calendar_integration": "Calendar Integration",
    "user_menu_copy_link": "Copy your link",
    "user_menu_link_copied": "Link copied",
    "name": "Name",
    "user_url": "User URL",
    "use_gravatar": "Use Gravatar",
    "save": "Save",
    "profile_updated": "Profile updated successfully",
    "error_saving_profile": "Error saving profile",
    "user_url_taken": "User URL already taken",
    "error_loading_profile": "Error loading profile",
    "login_with_sso": "Login with SSO",
    "login_with": "Log in with",
    "login_successful": "Login successful",
    "login_failed": "Login failed",
    "google_login_failed": "Google login failed",
    "Feedback": "Feedback",
    "Add": "Add",
    "Close": "Close",
    "I acknowledge that my password will be stored encrypted in the database.": "I acknowledge that my password will be stored encrypted in the database.",
    "event_copy_link": "Copy link",
    "link_copied_to_clipboard": "Link copied to clipboard!",
    "link_copy_failed": "Could not copy link to clipboard!",
    "copy": "Copy",
    "Availability Mode": "Availability Mode",
    "Define Custom": "Define Custom",
    "Use Standard": "Use Standard",
    "Standard + Extra": "Standard + Extra",
    "Standard + Constraints": "Standard + Constraints",
    "Standard Availability": "Standard Availability",
    "Using Standard Availability defined in Profile settings.": "Using Standard Availability defined in Profile settings.",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "Define your standard weekly availability here. You can use this availability in your Event Types.",
    "Copy Standard Availability": "Copy Standard Availability",
    "Overwrite current availability with standard?": "Overwrite current availability with standard?",
    "Profile": "Profile",
    "about": "About",
    "about_content": "# About AppointMe\n\nAppointMe is a simple tool for scheduling appointments.\nConfigure your calendars, set your availability, and let others book appointments with you.\n\n## Github\n[Check out the code on Github](https://github.com/fhswf/appointme)\n\n## Credits\nImplemented with ❤️ at the South Westphalia University of Applied Sciences",
    "legal": "Legal",
    "Calendar": "Calendar",
    "Select a calendar": "Select a calendar",
    "No calendar selected": "No calendar selected",
    "Choose calendars in which appointments are created.": "Choose calendars in which appointments are created.",
    "Calendar settings saved": "Calendar settings saved",
    "Failed to save settings": "Failed to save settings",
    "Failed to load calendars for": "Failed to load calendars for",
    "Google Calendar disconnected": "Google Calendar disconnected",
    "Failed to disconnect Google Calendar": "Failed to disconnect Google Calendar",
    "Connect a calendar to get started": "Connect a calendar to get started",
    "Enter your CalDav server details to connect your calendar.": "Enter your CalDav server details to connect your calendar.",
    "Failed to add account. Please check your credentials and server URL.": "Failed to add account. Please check your credentials and server URL.",
    "Email (Optional)": "Email (Optional)",
    "Online via Zoom": "Online via Zoom",
    "Language": "Language",
    "page not found": "page not found",
    "GO HOME": "GO HOME",
    "Impressum": "Imprint",
    "Datenschutzhinweise": "Privacy Policy",
    "privacy_content": `
# Privacy Policy

## Data Collection and Usage
This application collects and uses personal data to provide appointment scheduling services.

*   **User Profile:** We store your name, email address, and profile picture to identify you and personalize your experience.
*   **Google User Data:** If you connect your Google Calendar, we access your calendar data to:
    *   Check your availability to prevent double bookings.
    *   Create new events in your calendar when an appointment is booked.
    *   We do **not** use your Google Calendar data for any other purposes, such as advertising or market research.
*   **Calendar Data:** We store configuration settings for your connected calendars, event types you create (name, description, location), and appointment bookings.
*   **Log Data:** Your IP address is temporarily stored in server log files for security and troubleshooting.
*   **Telemetry:** We collect anonymous usage data and error reports using Sentry to improve application stability.

## Data Sharing
We do not share your personal data with third parties, except as necessary to provide the service or as required by law.

*   **Google User Data:** Data obtained from Google APIs is **not shared** with any third-party tools, AI models, or external entities, except as necessary to provide the calendar integration features (e.g., communicating with Google's servers).
*   **Service Providers:** We use Sentry for error tracking and application monitoring to ensure service stability. This provider may process IP addresses and other technical data strictly for service provision.
*   **Hosting:** The application is hosted on our own infrastructure (Kubernetes cluster). We do not use third-party CDNs or hosting providers that thereby gain access to your data.

## Data Storage and Protection
Your data is stored securely on our servers.
*   **Encryption:** All data transmitted between your browser and our servers is encrypted using HTTPS. Sensitive data such as access tokens are stored encrypted in our database.
*   **Access Control:** Access to your data is restricted to authorized personnel and is only accessed when necessary for support or maintenance.

## Data Retention and Deletion
*   **Retention:** We retain your user profile and calendar configuration data for as long as your account is active. Appointment data is retained to provide you with a history of your scheduled events.
*   **Deletion:** You have the right to request the deletion of your data. You can disconnect your Google Calendar at any time via the application settings, which will remove our access to your Google data. To request full account and data deletion, please contact us at gawron.christian@fh-swf.de or use the delete account feature in your profile settings.

## Google API Services User Data Policy
AppointMe's use and transfer to any other app of information received from Google APIs will adhere to [Google API Services User Data Policy](https://developers.google.com/terms/api-services-user-data-policy), including the Limited Use requirements.`,
    "privacy_content_public": `
# Privacy Policy

## Data Processing

For the purpose of booking an appointment, this application processes the data you provide (name, email address, description, date, and time of the appointment). This data is stored to manage the appointment and may be synced to the organizer's calendar.

## Telemetry

We use Sentry to collect anonymous telemetry data and error reports to improve the application stability.`,
    "impressum_content": "# Imprint\n\n## Disclaimer\nThe content on this server is not part of the official online offer of the South Westphalia University of Applied Sciences.",
    "CalDav Calendar": "CalDav Calendar",
    "loading": "Loading...",
    "Legal": "Legal",
    "new_event_type": "New Event Type",
    "Appointment Summary": "Appointment Summary",
    "Could not book event": "Could not book event",
    "error_no_calendar": "No calendar integration configured",
    "error_no_duration": "Duration must be greater than 0",
    "error_no_slots": "No time slots configured",
    "Active": "Active",
    "Inactive": "Inactive",
    "delete": "Delete",
    "Continue": "Continue",
    "Book Appointment": "Book Appointment",
    "Available Times": "Available Times",
    "No slots available": "No slots available",
    "Schedule Appointment": "Schedule Appointment",
    "Available Meeting Types": "Available Meeting Types",
    "Please select a meeting type to view availability.": "Please select a meeting type to view availability.",
    "All": "All",
    "No public events found.": "No public events found.",
    "Timezone": "Timezone",
    "Privacy & Terms": "Privacy & Terms",
    "Quick": "Quick",
    "Consulting": "Consulting",
    "Tags": "Tags",
    "Type a tag and press Enter": "Type a tag and press Enter",
    "Press Enter to add a tag": "Press Enter to add a tag",
    "Cancel": "Cancel",
    "landing_hero_title": "Appointment management <span class=\"text-primary\">made easy</span>",
    "landing_hero_subtitle": "Appoint Me is a simple and user-friendly solution for your appointments. Create events, share your link, and let others book appointments with you.",
    "landing_cta_start": "Start now",
    "landing_cta_learn_more": "Learn more",
    "landing_how_it_works_title": "How Appoint Me works",
    "landing_how_it_works_subtitle": "In just four simple steps to your organized calendar.",
    "landing_step1_title": "1. Configure calendar",
    "landing_step1_desc": "Determine where Appoint Me should enter appointments and where your availability should be checked. Connect your Google or Outlook calendar.",
    "landing_step2_title": "2. Create events",
    "landing_step2_desc": "Add your available times, define duration and break times, and get started!",
    "landing_step3_title": "3. Share your link",
    "landing_step3_desc": "Via your personal link, customers, colleagues, or friends can book appointments directly without annoying email ping-pong.",
    "landing_step4_title": "Done! Congrats!",
    "landing_step4_desc": "As soon as a user books an appointment, the event is automatically added to your calendar and both receive a confirmation.",
    "landing_footer_product": "Product",
    "landing_footer_features": "Features",
    "landing_footer_pricing": "Pricing",
    "landing_footer_integrations": "Integrations",
    "landing_footer_resources": "Resources",
    "landing_footer_documentation": "Documentation",
    "landing_footer_api": "API",
    "landing_footer_help_center": "Help Center",
    "landing_footer_legal": "Legal",
    "landing_footer_imprint": "Imprint",
    "landing_footer_privacy": "Privacy",
    "landing_footer_terms": "Terms & Conditions",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "Simple appointment planning for everyone.",
    "Contact": "Contact",
    "welcome_back": "Welcome back",
    "login_subtitle": "Please sign in to continue.",
    "login_tos_prefix": "By logging in you accept our",
    "terms_of_service": "Terms of Service",
    "help": "Help",
    "privacy": "Privacy",
    "imprint": "Imprint",
    "or": "or",
    "google": "Google",
    "sso_icon_alt": "SSO Icon",
    "SSO": "SSO",
    "footer_credits": "Programmed with ❤️ at the South Westphalia University of Applied Sciences",
    "terms_of_use_title": "Terms of Use",
    "terms_of_use_content": "# Terms of Use\n\n## Service Provision\n\nThis service is provided free of charge.\n\n## Disclaimer of Liability and Warranty\n\nNeither the authors nor the South Westphalia University of Applied Sciences accept any liability for damages of any kind or any warranty of any kind in connection with the use of this service. Use is at your own risk. This disclaimer does not apply to damages resulting from injury to life, body, or health based on an intentional or negligent breach of duty, nor to other damages based on an intentional or grossly negligent breach of duty.",
    "my_appointments": "My Appointments",
    "no_upcoming_appointments": "No upcoming appointments found.",
    "appointment": "Appointment",
    "attendee": "Attendee",
    "appointment_details": "Appointment Details",
    "close": "Close",
    "event_type": "Event Type",
    "week": "Week",
    "work_week": "Work Week",
    "day": "Day",
    "month": "Month",
    "today": "Today",
    "agenda": "Agenda",
    "more": "more",
    "next": "Next",
    "back": "Back",
    "n_more": "{{count}} more ...",
    "Grammatical Gender": "Grammatical Gender",
    "Male": "Male",
    "Female": "Female",
    "Neuter": "Neuter",
    "gender_help_text": "Used for correct grammar in confirmation messages.",
    "Recurrence": "Recurrence",
    "Enable Recurring Event": "Enable Recurring Event",
    "Frequency": "Frequency",
    "Weekly": "Weekly",
    "Bi-weekly": "Bi-weekly",
    "Tri-weekly": "Tri-weekly",
    "Monthly": "Monthly",
    "End Condition": "End Condition",
    "Occurrences": "Occurrences",
    "OR": "OR",
    "Until Date": "Until Date",
    "Time Span": "Time Span",
    "Months": "Months",
    "Weeks": "Weeks",
    "Recurring Event": "Recurring Event",
    "Recurring": "Recurring",
    "weekly": "Weekly",
    "biweekly": "Bi-weekly",
    "triweekly": "Tri-weekly",
    "monthly": "Monthly",
    "Series Booking Note: Students will book all occurrences at once.": "Series Booking Note: Students will book all occurrences at once.",
    "Student Only": "Student Only",
    "Restricted to Students": "Restricted to Students",
    "Settings exported successfully": "Settings exported successfully",
    "Failed to export settings": "Failed to export settings",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "Are you sure you want to import settings? This will overwrite your current profile and events.",
    "Settings imported successfully": "Settings imported successfully",
    "Failed to import settings": "Failed to import settings",
    "Invalid file format": "Invalid file format",
    "Data": "Data",
    "Export Settings": "Export Settings",
    "Download your settings and events as a JSON file.": "Download your settings and events as a JSON file.",
    "Export Data": "Export Data",
    "Import Settings": "Import Settings",
    "Restore your settings from a JSON file. This will overwrite existing data.": "Restore your settings from a JSON file. This will overwrite existing data.",
    "Select File": "Select File",
    "Online Meeting": "Online Meeting",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.",
    "Logout": "Logout",
    "MyProvider": "MyProvider",
    "confirmationText_male": "You booked an {{event}} with {{name}} appointment on {{date}} at {{time}}.",
    "confirmationText_female": "You booked an {{event}} with {{name}} appointment on {{date}} at {{time}}.",
    "confirmationText_neuter": "You booked an {{event}} with {{name}} appointment on {{date}} at {{time}}.",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "Failed to load changelog data.",
    "See what's new and what has been fixed.": "See what's new and what has been fixed.",
    "Reminder setting": "Reminder setting",
    "Notification type": "Notification type",
    "System notification": "System notification",
    "No reminder": "No reminder",
    "Reminder time": "Reminder time",
    "Reminder settings saved": "Reminder settings saved",
    "At event start": "At event start",
    "minutes before": "minutes before",
    "1 day before": "1 day before",
    "days before": "days before",
    "1 hour before": "1 hour before",
    "hours before": "hours before"
};
//# sourceMappingURL=en.js.map